// frontend/src/components/PaymentRedirect.js

import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import './PaymentRedirect.css'; // Create and import CSS as needed

const PaymentRedirect = () => {
  const location = useLocation();
  const { params, signature } = location.state || {};
  console.log("params",params)

  // useEffect(() => {
 
  //   if (params && signature) {
  //     // Prepare form data for vendor's payment page
  //     const form = document.createElement('form');
  //     form.method = 'POST';
  //     form.action = 'https://secureacceptance.cybersource.com/pay'; // Replace with your vendor's payment URL

  //     // Add hidden input fields
  //     Object.keys(params).forEach((key) => {
  //       const input = document.createElement('input');
  //       input.type = 'hidden';
  //       input.name = key;
  //       input.value = params[key];
  //       form.appendChild(input);
  //     });

  //     // Add signature field
  //     const signatureInput = document.createElement('input');
  //     signatureInput.type = 'hidden';
  //     signatureInput.name = 'signature';
  //     signatureInput.value = signature;
  //     form.appendChild(signatureInput);

  //     document.body.appendChild(form);
  //     form.submit();
  //   }
  // }, [params, signature]);

  return (
    <div className="redirect-container">
      <h2>Redirecting to Payment Gateway...</h2>
      <p>Please wait while we redirect you to the SecurePay payment page.</p>
    </div>
  );
};

export default PaymentRedirect;
